import { render, staticRenderFns } from "./infoRecords.vue?vue&type=template&id=06c1536e"
import script from "./infoRecords.vue?vue&type=script&lang=js"
export * from "./infoRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports